// ** Reducers Imports
import navbar from './navbar';
import layout from './layout';
import auth from './authentication';
import permission from './permission';
import users from '../views/Setup/User/store';
import roles from '../views/Setup/RoleRights/Role/store';
import moduleSlice from '../views/Setup/ModuleManage/store';
import config from '../views/Settings/Configuration/store/index';
import menuOrder from '../views/MenuOrder/store';
import module from '../views/Setup/ModuleManage/store';
import profile from '../views/UserProfile/Profile/store';
import templateGallery from '../views/TemplateGallery/store';
import projectSettings from '../views/ProjectSetting/store';
import auditLog from '../views/AuditLogs/store';
import editor from '../views/Editor/store';
const rootReducer = {
    auth,
    navbar,
    layout,
    permission,
    users,
    roles,
    moduleSlice,
    projectSettings,
    menuOrder,
    module,
    profile,
    // templateGallery,
    editor,
    config,
    auditLog
};

export default rootReducer;
